"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Stop = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Stop = function Stop(_ref) {
  var scheduledStopDuration = _ref.scheduledStopDuration,
      realStopDuration = _ref.realStopDuration;

  var _splitDuration = (0, _constants.splitDuration)(scheduledStopDuration),
      scheduledHours = _splitDuration.hours,
      scheduledMinutes = _splitDuration.minutes;

  var _splitDuration2 = (0, _constants.splitDuration)(realStopDuration),
      realHours = _splitDuration2.hours,
      realMinutes = _splitDuration2.minutes;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "block"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.stopDuration"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-title"
    }, message);
  }), scheduledStopDuration && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.target"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), scheduledStopDuration && /*#__PURE__*/_react["default"].createElement("span", null, scheduledHours, "h ", scheduledMinutes, "min"), realStopDuration && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.actual"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), realStopDuration && /*#__PURE__*/_react["default"].createElement("span", null, realHours, "h ", realMinutes, "min"));
};

exports.Stop = Stop;
Stop.propTypes = {
  realStopDuration: _propTypes["default"].number,
  scheduledStopDuration: _propTypes["default"].number
};
Stop.defaultProps = {
  realStopDuration: null,
  scheduledStopDuration: null
};
var _default = Stop;
exports["default"] = _default;